import K_Check from "../templates/K_Check";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface CheckOptions extends ComponentOptions {
    label?: string;
    hcLabel?: string;
    hcLabelAbove?: string;
    title?: string;
    showBox?: boolean;
    bindClasses?: string;
    valueClasses?: string;
    cf?: boolean;
    hideSS?: boolean;
}

export class Check extends TemplateComponent {

    options: CheckOptions;

    constructor(options: CheckOptions) {
        super(K_Check, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label;
    }

    /*
    * create
    * Wrapper for kendo template for Check Control
    *
    * data.id - Id for check
    * data.label - Title for check
    * data.toolTip - Check tooltip text
    * data.bind - Value to bind to
    * data.classes - Extra Classnames needed
    *
    */
    create() {
        var checkbox = $("#" + this.options.id);
        var bindValue = this.options.bindValue;

        checkbox.on("zCheckboxBind", function (e) {
            var observable = checkbox.data("bindData");
            var bind = checkbox.data("bind").slice(9); // remove 'checked: '

            var observableBindValue = observable[bind];

            if (observableBindValue) {
                if (observableBindValue === "False") {
                    observable[bind] = false;
                } else if (observableBindValue === "True") {
                    observable[bind] = true;
                }
            } else if (observableBindValue === null) { // make sure we only set null, not undefined
                observable[bind] = false;
            }

        });

        checkbox.tie("change", function (e) {
            var observable = checkbox.data("bindData");
            var checked = checkbox.prop("checked");

            if (!checked && observable) {
                observable.set(bindValue, "false");
                observable.set(bindValue, false);
            }
        });
    }

}
